/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetConnectionSettingsQueryResponse, SocialExportGetConnectionSettingsPathParams, SocialExportGetConnectionSettings400, SocialExportGetConnectionSettings401, SocialExportGetConnectionSettings403 } from "../models/SocialExportGetConnectionSettings";

export function getSocialExportGetConnectionSettingsUrl(id: SocialExportGetConnectionSettingsPathParams["id"]) {
  const res = { method: 'GET', url: `/social-export/v1/connections/${id}/settings` as const }
  return res
}

/**
 * @description Returns platform-specific settings for the connection, merged with platform defaults.
 * @summary Get connection settings by connection id
 * {@link /social-export/v1/connections/:id/settings}
 */
export async function socialExportGetConnectionSettings(id: SocialExportGetConnectionSettingsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportGetConnectionSettingsQueryResponse, ResponseErrorConfig<SocialExportGetConnectionSettings400 | SocialExportGetConnectionSettings401 | SocialExportGetConnectionSettings403>, unknown>({ method : "GET", url : getSocialExportGetConnectionSettingsUrl(id).url.toString(), ... requestConfig })
  return res.data
}